export default __webpack_public_path__ + "static/media/role.5c9c4db4.svg";